<template>

    <p class="c-form_desc">
        <slot></slot>
    </p>

</template>


<script>

export default {

    name: 'FormDesc'

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_desc {
    margin-bottom: 1.4rem;
    max-width: 500px;

    a {
        color: $c-primary;
        text-decoration: underline;
        cursor: pointer;
    }
}

</style>
